import type { ColumnDef } from "@tanstack/react-table";
import type { ActividadPrograma } from "@interfaces/actividadPrograma.interface";
import ActividadesProgramaActions from "@/components/AccionesTablas/ActividadesPrograma.acciones";
import { formatearFechaISOaDDMMYYYY } from "../utils";

export const columns: ColumnDef<ActividadPrograma>[] = [
  {
    accessorKey: "nombre",
    header: "Nombre",
  },
  {
    accessorKey: "fechaInicio",
    header: "Inicio",
    cell: ({ getValue }) => {
      const value = getValue() as string | null;
      return value ? formatearFechaISOaDDMMYYYY(value) : "";
    },
  },
  {
    accessorKey: "fechaFin",
    header: "Fin",
    cell: ({ getValue }) => {
      const value = getValue() as string | null;
      return value ? formatearFechaISOaDDMMYYYY(value) : "";
    },
  },
  {
    id: "acciones",
    header: "Acciones",
    cell: ({ row }) => <ActividadesProgramaActions actividad={row.original} />,
  },
];

